import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'EAppInformation',
    templateUrl: 'e-app-information.component.html',
    styleUrls: ['e-app-information.component.scss']
})

export class EAppInformationComponent implements OnInit {

    @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
    isShowSmartSaver: boolean = false
    constructor(private route: Router, private _global: PortalGlobals) {
    }

    ngOnInit() {
        if (this._global.selectedPlanYear >= this._global.Planyear2023)
        { this.isShowSmartSaver = true }
        else {
            this.isShowSmartSaver = false
        }

    }
    onClick() {
        this.notify.emit(false);
    }
    public watchVideo() {
        window.open('https://agentportal.sit2a.meddweb.net/agentportal/video/eApp.mp4', '_blank')
    }
}
